import React from 'react';

import Button from 'common/components/Button';
import trans from 'common/tools/translations/trans';

import styles from './styles.module.scss';

type AddToCollectionModalButtonsBarProps = {
  onClick: () => void;
  onClose: () => void;
};
const AddToCollectionModalButtonsBar = ({
  onClick,
  onClose
}: AddToCollectionModalButtonsBarProps) => (
  <div className={styles.addToCollectionButtonBar}>
    <Button theme="default" onClick={onClose}>
      {trans('userspace.my-collections.addCollectionEntityModal.cancel')}
    </Button>
    <Button theme="inverse" onClick={onClick}>
      {trans('userspace.my-collections.addCollectionEntityModal.save')}
    </Button>
  </div>
);

export default AddToCollectionModalButtonsBar;
